import React, { useState, useEffect, useReducer, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { parseISO, format } from "date-fns";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import toastError from "../../errors/toastError";

const reducer = (state, action) => {
	if (action.type === "LOAD_LOGS") {
		console.log(state);
		console.log(action.payload);

		const logs = action.payload;
		const newLogs = [];

		logs.forEach(log => {
			const logIndex = state.findIndex(l => l.id === log.id);
			if (logIndex !== -1) {
				state[logIndex] = log;
			} else {
				newLogs.push(log);
			}
		});

		console.log(newLogs);

		return [...state, ...newLogs];
	}

	if (action.type === "RESET") {
		return [];
	}
};

const useStyles = makeStyles(theme => ({
	mainPaper: {
		flex: 1,
		padding: theme.spacing(1),
		overflowY: "scroll",
		...theme.scrollbarStyles,
	},
}));

const UserLogs = () => {
	const { user: loggedInUser } = useContext(AuthContext);
	const { userId } = useParams();
	const history = useHistory();

	// if (loggedInUser.id > 3 && loggedInUser.id != 8 && loggedInUser.id != userId) {
	if (loggedInUser.id > 3 && loggedInUser.id !== 8) {
		history.push("/");
	}

	const classes = useStyles();

	const [loading, setLoading] = useState(false);
	const [pageNumber, setPageNumber] = useState(1);
	const [hasMore, setHasMore] = useState(false);
	const [logs, dispatch] = useReducer(reducer, []);

	useEffect(() => {
		setLoading(true);
		const delayDebounceFn = setTimeout(() => {
			const fetchLogs = async () => {
				try {
					const { data } = await api.get("/userlogs/", {
						params: { userId, pageNumber },
					});
					dispatch({ type: "LOAD_LOGS", payload: data.logs });
					setHasMore(data.hasMore);
					setLoading(false);
				} catch (err) {
					toastError(err);
				}
			};
			fetchLogs();
		}, 500);
		return () => clearTimeout(delayDebounceFn);
	}, [userId, pageNumber]);

	const loadMore = () => {
		setPageNumber(prevState => prevState + 1);
	};

	const handleScroll = e => {
		if (!hasMore || loading) return;
		const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
		if (scrollHeight - (scrollTop + 100) < clientHeight) {
			loadMore();
		}
	};

	return (
		<MainContainer>
			<MainHeader>
				<Title>{i18n.t("userLogs.title")}</Title>
			</MainHeader>
			<Paper
				className={classes.mainPaper}
				variant="outlined"
				onScroll={handleScroll}
			>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell align="center">
								{i18n.t("userLogs.table.loginTime")}
							</TableCell>
							<TableCell align="center">
								{i18n.t("userLogs.table.lastAccess")}
							</TableCell>
							<TableCell align="center">
								{i18n.t("userLogs.table.logoutTime")}
							</TableCell>
							<TableCell align="center">
								{i18n.t("userLogs.table.user")}
							</TableCell>
							<TableCell align="center">
								{i18n.t("userLogs.table.ipAddress")}
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<>
							{logs.map(log => (
								<TableRow key={log.id}>
									<TableCell align="center">{format(parseISO(log.loginAt), "d MMM yyyy HH:mm:ss")}</TableCell>
									<TableCell align="center">{format(parseISO(log.lastVisit), "d MMM yyyy HH:mm:ss")}</TableCell>
									<TableCell align="center">{log.logoutAt ? format(parseISO(log.logoutAt), "d MMM yyyy HH:mm:ss") : "-"}</TableCell>
									<TableCell align="center">{log.user.name}</TableCell>
									<TableCell align="center">{log.ipAddress}</TableCell>
								</TableRow>
							))}
							{loading && <TableRowSkeleton columns={4} />}
						</>
					</TableBody>
				</Table>
			</Paper>
		</MainContainer>
	);
};

export default UserLogs;
